import { Component, OnInit } from '@angular/core';
import { AnalyticEvents } from '@app/enums';
import { PerformanceMenuService } from '@app/modules/performance/services';
import { AnalyticService } from '@app/services';
import { AuthService } from '@app/services/auth.service';
import { IndexView } from '@common/views/index/index.view';
import { Goal } from '@models/performance/goal.model';
import { GoalIndexTable } from '@performance/services/tables/goal-table/goal-index.table';

@Component({
    templateUrl: './goal-index.template.html',
    styleUrls: ['./goal-index.style.scss'],
})
export class GoalIndexView extends IndexView implements OnInit {
    createPermission = Goal.permission.edit;

    constructor(
        protected auth: AuthService,
        public table: GoalIndexTable,
        private analyticService: AnalyticService,
        public performanceMenuService: PerformanceMenuService
    ) {
        super();
        this.table.reload();
    }

    trackCreatingGoal(): void {
        this.analyticService.trackEvent(AnalyticEvents.PerformanceGoalsClickCreateGoal);
    }

    onCreate(): void {}

    ngOnInit(): void {}
}
